"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Icons = _interopRequireDefault(require("../baseComponents/Icons"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Tabs = function Tabs(props) {
  var type = props.type,
      contents = props.contents,
      tabStyle = props.tabStyle,
      className = props.className,
      style = props.style,
      rest = _objectWithoutProperties(props, ["type", "contents", "tabStyle", "className", "style"]);

  var componentClasses = (0, _classnames["default"])("tabs-component", type, tabStyle, className);

  var menus = _react["default"].Children.toArray(props.children);

  var tabs = contents.map(function (item, index) {
    var tabClasses = (0, _classnames["default"])('tab', item.className, {
      "selected": typeof props.selectedTab === "string" ? props.selectedTab === item.id : props.selectedTab === index
    });
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: tabClasses,
      onClick: function onClick(e) {
        props.onClick(e, item, index);
      },
      key: index,
      id: index,
      style: item.style
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "tab-content"
    }, item.content, type === "horizontal-ext-1" && index > 0 && /*#__PURE__*/_react["default"].createElement(_Icons["default"], {
      name: "micro-glyph-arrow-head"
    })));
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: componentClasses,
    style: style
  }, tabs);
};

Tabs.propTypes = {
  type: _propTypes["default"].oneOf(["vertical", "horizontal", "horizontal-ext-1"]),
  contents: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    id: _propTypes["default"].string,
    content: _propTypes["default"].any,
    className: _propTypes["default"].string,
    style: _propTypes["default"].object
  })),
  className: _propTypes["default"].string,
  style: _propTypes["default"].object,
  onClick: _propTypes["default"].func,
  tabStyle: _propTypes["default"].oneOf(["", "round"]),
  selectedTab: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string])
};
Tabs.defaultProps = {
  type: "horizontal",
  contents: [],
  className: "",
  style: {},
  onClick: function onClick() {},
  tabStyle: "",
  selectedTab: null
};
var _default = Tabs;
exports["default"] = _default;